import axios from "axios";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { createConfig } from "@Utils/createConfig";
const exportAllSlides = {
    slideIds: null,
    // No intro or thank-you slide, so nothing in the deck is dated.
    timeZone: "UTC",
    exportOptions: {
        genIntro: false,
        genThankYou: false,
        genAppendices: {
            preSlides: [],
            postSlides: []
        },
        showPPTXView: false,
        autoAdjustElements: false,
        shouldSnapToPptxAnchorPoints: false
    }
};
export async function structureImportWorkflow(token, workspaceId) {
    return await axios.post(`${gatewayUrl}/workspaces/workspaceToImage/${workspaceId}`, exportAllSlides, createConfig(token));
}
